import { ChapterDivider } from '@/components/ChapterDivider';
import { MarkdownPreview } from '@/components/publisher/MarkdownPreview';
import { Chapter } from '@/types';

interface ChapterListProps {
  chapters: Chapter[];
  setChapterRef: (el: HTMLElement | null, chapterId: string) => void;
}

export function ChapterList({ chapters, setChapterRef }: ChapterListProps) {
  return (
    <>
      {chapters.map((chapter, index) => (
        <div 
          key={chapter._id}
          ref={(el) => setChapterRef(el, chapter._id)}
          data-chapter={chapter.sequence}
          id={`chapter-${chapter.sequence}`}
        >
          {/* Chapter Header */}
          {index > 0 && (
            <ChapterDivider 
              chapterNumber={chapter.sequence}
              chapterTitle={chapter.title}
            />
          )}
          
          {index === 0 && (
            <header className="mb-12 text-center">
              <p className="font-ui text-[10px] text-[var(--text-tertiary)] uppercase tracking-[0.3em] mb-3">
                Chapter {chapter.sequence}
              </p>
              <h1 className="font-body text-2xl md:text-3xl font-medium text-[var(--text-primary)]">
                {chapter.title}
              </h1>
            </header>
          )}

          {/* Chapter Content */}
          <div className="chapter-content space-y-6">
            {chapter.content?.map((block, idx: number) => {
              if (block.type === 'audio') {
                return (
                  <p key={idx} className="my-6">
                    {block.placeholder && <span className="text-[var(--text-secondary)]">{block.placeholder} </span>}
                    <span className="text-[var(--accent)]">[Audio: {block.audioId}]</span>
                  </p>
                );
              }
              return (
                <div key={idx} className="text-[var(--text-primary)]">
                  <MarkdownPreview markdown={block.text || ''} />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
}
